export default "__VITE_ASSET__Clih79_P__"